import styled from "styled-components";

export const MenusDiv = styled.div`
  border: 1px solid #fff;
  border-radius: 5px;
  padding: 1px;

  > button {
    margin: 0 0.4em;

    > svg:hover > path,
    > svg:hover {
      fill: #dccaa445;
    }
  }
`;